import { useState, useEffect } from "react";
import {useNavigate} from 'react-router-dom';
// import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
// import headerImg from "../assets/img/me-avatar-1.jpg";
// import headGif from "../assets/img/head_gif.gif";
export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setisDeleting] = useState(false);
  const [delta, setDelta] = useState(3 - Math.random() * 100);
  const toRotate = ["Full Stack Dev", "ML Enthusiast", "web Designer"];
  const [text, setText] = useState(""); // eslint-disable-next-line
  const period = 40;

  const navigate = useNavigate();
  const handleClickScroll = () => {
    navigate('/contact');
  };
  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);
    return () => {
      clearInterval(ticker);
    };
    // eslint-disable-next-line
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta );
    }

    if (!isDeleting && updatedText === fullText) {
      setisDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setisDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(300);
    }
  };
  
  return (
    
    <section className="banner" id="home">
      <div className="home-box">
        <div>
        <div className="home-content">
          <div className="tagline">
          <span >Welcome to My Portfolio</span>
           {/* eslint-disable-next-line */}
          <a target='_blank' className="resumelink" href="https://docs.google.com/document/d/1jRP1PBOsqAXhAttilGOhNRj1rgAC6CRD28Era9nqYo4/edit?usp=drive_link">|Resume</a>
          </div>
          <h1>
            {" Hey ! "}
            <br></br>
            {"I am Abhishek"}
            <br></br>

            <span className="wrap">{text}</span>
            
          </h1>
          </div>
          {/* <div className="changecontent"> */}
          
          
          <div className="home-content">
            <div className="fixedhometext">
              <h6>
                {" "}
                coder {"<<"} Learner {"<<"} thinker{" "}
              </h6>
              <h6>"It's not a bug, it's an undocumented feature." - Anonymous</h6>
            </div>
            <button onClick={handleClickScroll}>
              Let's connect
              <ArrowRightCircle size={25} />
            </button>
        </div>
        </div>
      </div>
    </section>
  );
};
